import axios from "axios";
import store from "../store/index.js";
import router from "../router.js";
import { Toast } from "vant";

let baseURL =
  process.env.NODE_ENV === "development"
    ? "http://119.23.230.194:8083/v1/"
    : "https://dgyz.cg1717.com/v1/";

baseURL = "https://dgyz.cg1717.com/v1/";// 生产
// baseURL = "http://123.207.84.50:8083/v1/";// 测试

// 默认配置
axios.defaults.baseURL = baseURL;
axios.defaults.headers.post["Content-Type"] = "application/json;charset=utf8";
let loading = false;

// http request 拦截器
axios.interceptors.request.use(
  config => {
    if (!loading && !config.unLoading) {
      loading = true;
      Toast.loading({
        message: "加载中...",
        mask: true,
        duration: 0
      });
    }
    if (store.state.token) {
      config.headers.Authorization = store.state.token;
    }
    return config;
  },
  error => {
    if (loading) Toast.clear();
    return Promise.reject(error);
  }
);

// http response 拦截器
axios.interceptors.response.use(
  response => {
    if (loading) {
      Toast.clear();
      loading = false;
    }
    switch (response.data.code) {
      case 200:
        break;
      case 401:
        if (!router.history.current.meta.requireAuth) break;
        store.commit("logout");
        router.currentRoute.path !== "/user/login" &&
          router.replace({
            path: "/user/login",
            query: { redirect: router.currentRoute.fullPath }
          });
        break;
      default:
        Toast({
          message: response.data.msg,
          duration: 2000
        });
        break;
    }
    return response;
  },
  error => {
    if (error.response) {
      switch (error.response.status) {
        case 401:
          store.commit("logout");
          router.currentRoute.path !== "Login.vue" &&
            router.replace({
              path: "/login",
              query: { redirect: router.currentRoute.fullPath }
            });
      }
    }
    return Promise.reject(error);
  }
);

export default axios;
